module.exports = __webpack_public_path__ + "img/logo_google_g_icon.45aebcf8.svg";